import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { faCheck, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-bidding-question-mark',
  imports: [ButtonModule, DialogModule, FontAwesomeModule],
  templateUrl: './bidding-question-mark.component.html',
  styleUrl: './bidding-question-mark.component.scss'
})
export class BiddingQuestionMarkComponent {
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  faCheck = faCheck;
  faCheckCircle = faCheckCircle;

  onClose() {
    this.close.emit();
  }
}
